import { setInnerTextById, setSubscriptionNameInUI, redirectToPreferencesPage, getSubscriptionNameFromDefinition, redirectToFallbackPage } from 'CmsManagePreferences/js/utils/common';
import { DOM_IDS } from 'CmsManagePreferences/js/utils/constants';
function getSubscriptionName(preferences) {
  const {
    sentSubscriptionId,
    subscriptionStatuses
  } = preferences;
  if (sentSubscriptionId) {
    const subscription = subscriptionStatuses === null || subscriptionStatuses === void 0 ? void 0 : subscriptionStatuses.find(s => s.id === sentSubscriptionId);

    // switch to use getTranslatedDefinition once language select is added
    const translatedDefinition = getSubscriptionNameFromDefinition(subscription === null || subscription === void 0 ? void 0 : subscription.translations);
    return translatedDefinition || '';
  }
  return '';
}
export default function loadSingleSubscriptionUI(preferences) {
  const {
    maskedEmail,
    testSend,
    sentSubscriptionId,
    subscriptionStatuses
  } = preferences;
  if (!(subscriptionStatuses !== null && subscriptionStatuses !== void 0 && subscriptionStatuses.length)) {
    redirectToFallbackPage();
    return;
  }
  if (maskedEmail) {
    setInnerTextById(DOM_IDS.emailPlaceholder, maskedEmail);
  }
  if (testSend && (sentSubscriptionId === 0 || sentSubscriptionId === 1)) {
    return;
  }
  const subscriptionName = getSubscriptionName(preferences);
  if (!subscriptionName) {
    redirectToPreferencesPage();
    return;
  }
  setSubscriptionNameInUI(subscriptionName);
}